import { StyleObj } from '../../../@types';

const BORDER = '1px solid rgba(0, 83, 55, 0.20)';
const baseInputStyle = {
  backgroundColor: 'white',
  '& .MuiOutlinedInput-notchedOutline': {
    border: BORDER,
    borderRadius: 1,
  },
};

export const styles: StyleObj = {
  tableContainer: {
    mt: 2,
    boxShadow: 0,
    border: BORDER,
    borderRadius: 1,
    '& .MuiTableHead-root .MuiTableCell-root': {
      background: 'white',
      color: 'inherit',
    },
    '& .MuiTableCell-root': {
      borderBottom: BORDER,
    },
  },
  gridContainer: {
    '& .MuiFormLabel-root': {
      letterSpacing: '0.5px',
    },
  },
  userName: {
    typography: 'h5',
    fontSize: 16,
    letterSpacing: 0.8,
  },
  input: {
    ...baseInputStyle,
    '& .MuiOutlinedInput-notchedOutline > legend > span': {
      paddingRight: '12px',
    },
  },
  inputWithoutPadding: baseInputStyle,
  perPickInput: {
    '& fieldset': { border: 'none' },
    '& input': {
      textAlign: 'center',
    },
    '& .MuiOutlinedInput-root.Mui-error': {
      color: 'error.main',
    },
  },
  rightBorderCell: { borderRight: BORDER },
  editButton: {
    p: 0,
    ':hover': {
      background: 'transparent',
    },
  },
};
